import { Helmet } from "react-helmet";
import { useContext, useState } from "react";
import SecondHeader from "../Header/SecondHeader";
import trans from "../../utils";
import { popupcontext } from "../../context/Popupscontext";
import usePermission from "../../hooks/usePermission";
import RecurringPlannersHeader from "./RecurringPlannersHeader";
import RecurringPlannersList from "./List/RecurringPlannersList";
import RecurringPlannerForm from "./Forms/RecurringPlannerForm";

const RecurringPlanners = () => {
	const { handleShow } = useContext(popupcontext);
	const { create } = usePermission("FIELD_TASKS");
	const [statusFilter, setStatusFilter] = useState("");

	return (
		<>
			<Helmet>
				<title>{trans("Recurring Planners")}</title>
				<meta name="description" content="Recurring task planners" />
			</Helmet>
			<SecondHeader
				add={create ? trans("Add Recurring Planner") : null}
				onClick={() => handleShow("addForm")}
			/>
			<RecurringPlannersHeader
				statusFilter={statusFilter}
				setStatusFilter={setStatusFilter}
			/>
			<RecurringPlannersList statusFilter={statusFilter} />
			<RecurringPlannerForm />
		</>
	);
};

export default RecurringPlanners;
